import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { BrandCampaign } from "../../../../../shared/models/brandCampaign";
import { BrandCampaignDetails } from "../../../../../shared/models/brandCampaignDetail";
import { Image } from "../../../../../shared/models/image";

export type BrandCampaignDetailsPreviewDialogData = BrandCampaign;
export type BrandCampaignDetailsPreviewDialogResult = undefined;

@Component({
  selector: "app-brand-campaign-details-preview-dialog",
  templateUrl: "./brand-campaign-details-preview-dialog.component.html",
  styleUrls: ["./brand-campaign-details-preview-dialog.component.scss"],
})
export class BrandCampaignDetailsPreviewDialogComponent {
  public readonly SLIDE_TRANSITION_MS = 500;
  public campaign: BrandCampaign;
  public campaignDescription: SafeHtml;
  public campaignDetails: BrandCampaignDetails;
  public currentImage?: Image;
  public currentImageIdx = 0;
  public isFading = false;
  public nextImage?: Image;

  constructor(
    sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignDetailsPreviewDialogData,
  ) {
    this.campaign = data;
    this.campaignDetails = this.campaign.currentDetails;
    this.campaignDescription = sanitizer.bypassSecurityTrustHtml(
      this.campaignDetails.description ?? "",
    );

    if (this.campaignDetails.sliders.length > 0) {
      this.currentImage = this.campaignDetails.sliders[0];
      this.nextImage = this.campaignDetails.sliders[0];
    }
  }

  public showImage(index: number): void {
    // Only allow changing image if the slider is idle
    if (this.isFading) {
      return;
    }

    this.currentImageIdx = index;
    this.isFading = true;
    this.nextImage = this.campaignDetails.sliders[index];

    setTimeout(() => {
      this.currentImage = this.nextImage;
      this.isFading = false;
    }, this.SLIDE_TRANSITION_MS);
  }

  public showNext(): void {
    this.showImage(
      (this.currentImageIdx + 1) % this.campaignDetails.sliders.length,
    );
  }
}
